const NOTCHANGEABLE_PROFILE_DATA = [
  {
    name: "fullName",
    label: "Display Name",
  },
  {
    name: "firstName",
    label: "First Name",
  },
  {
    name: "lastName",
    label: "Last Name",
  },
  {
    name: "email",
    label: "Email Address",
  },
  {
    name: "password",
    label: "Password",
  },
  {
    name: "address",
    label: "Shipping Address",
  },
  {
    name: "phone",
    label: "Phone Number",
  },
];

const PROFILE_DATA = [
  {
    name: "fullName",
    label: "Display Name",
  },
  {
    name: "email",
    label: "Email Address",
  },
  { name: "firstName", label: "First Name" },
  {
    name: "lastName",
    label: "Last Name",
  },

  {
    name: "phone",
    label: "Phone Number",
  },
];

const ADDRESS = [
  {
    name: "address",
    label: "Address",
  },
  { name: "address2", label: "Address Line 2" },
  {
    name: "zipCode",
    label: "Zip Code",
  },
  {
    name: "city",
    label: "City",
  },
];

const PASSWORD = [
  {
    name: "password",
    label: "Current Password",
  },
  {
    name: "newPassword",
    label: "New Password",
  },
  {
    name: "confirmNewPassword",
    label: "Confirm New Password",
  },
];

// Test report data
const PET_DETAIL = [
  {
    label: "patient name",
    value: "Max",
  },
  {
    label: "gender",
    value: "Male Nuetered",
  },
  {
    label: "pet's parent",
    value: "Doggo",
  },
  {
    label: "age",
    value: "9 Years",
  },
  {
    label: "species",
    value: "Canine",
  },
  {
    label: "hospital",
    value: "Armadale",
  },
  {
    label: "breed",
    value: "Golden Retriever",
  },
];

const ORDER_INFO = [
  {
    label: "order number",
    value: "301",
  },
  {
    label: "sample received",
    value: "02/16/2023",
  },
  {
    label: "result reported",
    value: "02/22/2023",
  },
];

const RISK_STEPS = [
  {
    low: (
      <>
        <li>
          There is no need to worry about the 4 most common cancers at this
          point.
        </li>
        <li>
          We recommend taking the test as an annual cancer screening test.
        </li>
        <li>
          For older dogs and high risk breeds, we recommend taking the test
          every 3 to 6 months depending on the condition.
        </li>
        <li>See FAQs for more information</li>
      </>
    ),
    moderate: (
      <>
        <li>We suggest visiting your vet for further consultation. </li>
        <li>If no clinical signs of cancer, repeat the test in 3 months.</li>
        <li>
          If clinically suspected, talk to your veterinarian about diagnostic
          testing options, such as x-rays and ultrasounds to confirm or deny
          cancer suspicion.
        </li>
        <li>See FAQs for more information</li>
      </>
    ),
    high: (
      <>
        <li>We suggest visiting your vet for further consultation.</li>
        <li>
          May represent high levels of circulating cancerous volatile
          metabolites.
        </li>
        <li>
          Talk to your veterinarian about taking additional diagnostic tests
          such as x-rays and ultrasounds to confirm or deny cancer suspicion.
        </li>
        <li>See FAQs for more information</li>
      </>
    ),
  },
];

const RISK_MEANS = [
  {
    low: (
      <>
        <li>
          Consistent with those found in healthy dogs of all genders and ages
        </li>
        <li>
          Please note that as with any laboratory test, the Oncotect test result
          must be interpreted by a veterinarian in the context of each patient's
          medical history and clinical presentation.
        </li>
        <li>
          The Oncotect test screens for lymphoma, hemangiosarcoma, mast cell
          tumor, and melanoma.
        </li>
      </>
    ),
    moderate: (
      <>
        <li>May represent low levels of circulating cancer cells.</li>
        <li>
          Clinical signs of cancer include lumps and bumps, abnormal odors,
          abnormal discharges, non-healing wounds, weight loss, change in
          appetite, lethargy, evidence of pain, etc.{" "}
        </li>
        <li>
          Clinical data shows that 60% of moderate risk cases turn out to be
          actual cancer cases.
        </li>
        <li>
          Please note that as with any laboratory test, the Oncotect test result
          must be interpreted by a veterinarian in the context of each patient's
          medical history and clinical presentation.
        </li>
        <li>
          The Oncotect test screens for lymphoma, hemangiosarcoma, mast cell
          tumor, and melanoma.
        </li>
      </>
    ),
    high: (
      <>
        <li>
          Consistent with those found in common canine cancers including Mast
          Cell Tumor, Hemangiosarcoma, Lymphoma, and Melanoma.
        </li>
        <li>
          Clinical data shows that 80% of high risk cases turn out to be actual
          cancer cases.
        </li>
        <li>
          Please note that as with any laboratory test, the Oncotect test result
          must be interpreted by a veterinarian in the context of each patient's
          medical history and clinical presentation.
        </li>
        <li>
          The Oncotect test screens for lymphoma, hemangiosarcoma, mast cell
          tumor, and melanoma.
        </li>
      </>
    ),
  },
];

const CONTACT_INFO = [
  {
    label: "Hospital Name",
    value: "BayCountry Veterinary",
  },
  {
    label: "Email",
    value: "Saudawan@altaurux.com",
  },
  {
    label: "Phone",
    value: "9642786234",
  },
  {
    label: "Zip Code",
    value: "60500",
  },

  {
    label: "Address",
    value: "Rawalpindi",
  },
  {
    label: "Apartment/Suite",
    value: "Rawalpindi",
  },
  {
    label: "City",
    value: "Rawalpindi",
  },
  {
    label: "State",
    value: "Rawalpindi",
  },
];
const CARE_TEAM_CONTACT = [
  { name: "Hospital Name", type: "text", placeholder: "Enter Name" },
  { name: "Veterinarian Name", type: "text", placeholder: "Enter Name" },
  { name: "Email", type: "email", placeholder: "Enter your Email" },
  { name: "Phone Number", type: "number", placeholder: "Enter Phone Number" },
  { name: "Address", type: "text", placeholder: "Enter Address" },
  {
    name: "Apartment, Suite, Building",
    type: "text",
    placeholder: "Enter Address Line 2",
  },
  { name: "City", type: "text", placeholder: "Enter City" },
  { name: "Zip Code", type: "text", placeholder: "Enter Zip City" },
];
export {
  NOTCHANGEABLE_PROFILE_DATA,
  PROFILE_DATA,
  ADDRESS,
  PASSWORD,
  PET_DETAIL,
  ORDER_INFO,
  RISK_STEPS,
  RISK_MEANS,
  CONTACT_INFO,
  CARE_TEAM_CONTACT,
};
